import React from 'react'

const IconSms = props =>
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64' {...props}>
    <rect x='10' y='2' width='32' height='60' rx='5' fill='black' />
    <rect x='14' y='8' width='24' height='42' rx='1.5' fill='white' />
    <circle cx='26' cy='56' r='2.5' fill='white' />
    <path d='M36 18h16c2.2 0 4 1.8 4 4v12c0 2.2-1.8 4-4 4h-8l-6 6v-6h-2c-2.2 0-4-1.8-4-4V22c0-2.2 1.8-4 4-4z'
      fill='white'
      stroke='black'
      strokeWidth='2'
    />
  </svg>

export default IconSms
